import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useAuth } from "@redwoodjs/auth";
import { Redirect, routes } from "@redwoodjs/router";
import Cookies from "js-cookie";
import { Box, Link, Typography } from "src/components/material-ui";
import ErrorPageLayout from "src/components/ErrorPageLayout/ErrorPageLayout";
import {
  ID_TOKEN_COOKIE,
  ACCESS_TOKEN_COOKIE,
  REFRESH_TOKEN_COOKIE,
} from "src/auth/hecate";

const FatalErrorPage = () => {
  const { hasError } = useAuth();
  const loginError = React.useRef(Cookies.get("login_error")).current;

  useEffect(() => {
    Cookies.remove("login_error");
  }, []);

  useEffect(() => {
    if (!hasError && !loginError) {
      return;
    }

    Cookies.remove(ID_TOKEN_COOKIE);
    Cookies.remove(ACCESS_TOKEN_COOKIE);
    Cookies.remove(REFRESH_TOKEN_COOKIE);
  });

  if (!hasError && !loginError) {
    return <Redirect to={routes.home()} />;
  }

  return (
    <ErrorPageLayout>
      <Box mb={8}>
        <Typography variant="display1" align="center">
          <FormattedMessage
            id={hasError ? "unableToLoad" : "somethingWentWrong"}
          />
        </Typography>
      </Box>

      <Box>
        <Typography variant="body1" align="center">
          <FormattedMessage
            id={
              hasError ? "fatalErrorFirstSentence" : "loginErrorFirstSentence"
            }
            values={
              hasError
                ? {
                    refreshPage: (
                      <Link
                        onClick={() => {
                          location.reload();
                        }}
                      >
                        <FormattedMessage id="refreshPage" />
                      </Link>
                    ),
                  }
                : {
                    refreshPage: (
                      <Link
                        onClick={() => {
                          location.reload();
                        }}
                      >
                        <FormattedMessage id="refreshPage" />
                      </Link>
                    ),
                    systemStatus: (
                      <Link
                        onClick={() => {
                          window.open("https://status.loopup.com", "_blank");
                        }}
                      >
                        <FormattedMessage id="systemStatusPage" />
                      </Link>
                    ),
                  }
            }
          />{" "}
          <FormattedMessage
            id={
              hasError ? "fatalErrorSecondSentence" : "loginErrorSecondSentence"
            }
          />
          {loginError && <span className="email"> support@loopup.com</span>}
        </Typography>
      </Box>
    </ErrorPageLayout>
  );
};

export default FatalErrorPage;
